import { get } from 'lodash-es';
import useRef from '@/util/hook/useRef';
export const useScrollToInputField = () => {
    const genderRef = useRef(null);
    const heightRef = useRef(null);
    const weightRef = useRef(null);
    const ageRef = useRef(null);
    const hospitalBedRef = useRef(null);
    const symptomRef = useRef(null);
    const tubeRef = useRef(null);
    const requiredGenderRef = useRef(null);
    const servedItemRef = useRef(null);
    const langRef = useRef(null);
    const hospitalObjRef = useRef(null);
    const notesRef = useRef(null);
    const contactNameRef = useRef(null);
    const contactGenderRef = useRef(null);
    const contactPhoneRef = useRef(null);
    const contactEmailRef = useRef(null);
    const timeSlotListRef = useRef(null);
    const scrollToInputField = ({ fieldElement }) => {
        if (!fieldElement)
            return;
        const elOffsetTop = get(fieldElement, 'offsetTop');
        window.scroll({
            top: elOffsetTop,
            behavior: 'smooth',
        });
    };
    const careOrderBabyFormInputFieldRefMap = {
        gender: genderRef,
        height: heightRef,
        weight: weightRef,
        age: ageRef,
        hospitalBed: hospitalBedRef,
        symptom: symptomRef,
        tube: tubeRef,
        requiredGender: requiredGenderRef,
        servedItem: servedItemRef,
        lang: langRef,
        hospitalObj: hospitalObjRef,
        notes: notesRef,
        contactName: contactNameRef,
        contactGender: contactGenderRef,
        contactPhone: contactPhoneRef,
        contactEmail: contactEmailRef,
        timeSlotList: timeSlotListRef,
    };
    return {
        scrollToInputField,
        careOrderBabyFormInputFieldRefMap,
    };
};
